import { createFileRoute, redirect } from '@tanstack/react-router'

import { requireAuthentication } from '@/features/auth/route-access'

/** Keep existing bookmarks working with the invitation-link group flow. */
export const Route = createFileRoute('/onboard')({
  beforeLoad: () => {
    requireAuthentication()
    throw redirect({ to: '/groups', replace: true })
  },
})
